<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    class="heroicon-briefcase heroicon heroicon-sm"
  >
    <path
      class="heroicon-briefcase-case heroicon-component-fill"
      fill="#FFFFFF"
      d="M1 14a1 1 0 0 1 1-1h56a1 1 0 0 1 1 1v42a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V14z"
    ></path>
    <path
      class="heroicon-briefcase-flap-lip heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M52 38H35.83a3 3 0 0 0-.6-1H52a5 5 0 0 0 5-5V14h1v18a6 6 0 0 1-6 6zm-27.83 0H8a6 6 0 0 1-6-6V14h1v18a5 5 0 0 0 5 5h16.76a3 3 0 0 0-.59 1z"
    ></path>
    <path
      class="heroicon-briefcase-strap heroicon-component-fill"
      fill="#FFFFFF"
      d="M34 41v-8l-4-4-4 4v8h-2v5a3 3 0 0 0 3 3c.56 0 1.32.32 1.71.71L30 51l1.29-1.29c.4-.4 1.16-.71 1.72-.71A3 3 0 0 0 36 46v-5h-2z"
    ></path>
    <path
      class="heroicon-briefcase-handle heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M19 10h-2v3h8v-3h-2V5h14v5h-2v3h8v-3h-2V4a3 3 0 0 0-3-3H22a3 3 0 0 0-3 3v6z"
    ></path>
    <path
      class="heroicon-briefcase-buckle heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M34 42h2v-3a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v3h2v1a3 3 0 0 0 3 3h2a3 3 0 0 0 3-3v-1z"
    ></path>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M36 42v-2h16a8 8 0 0 0 8-8v2a8 8 0 0 1-8 8H36zm-12 0H8a8 8 0 0 1-8-8v-2a8 8 0 0 0 8 8h16v2zm10 .5V45a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3v-2.5.5a3 3 0 0 0 3 3h2a3 3 0 0 0 3-3v-.5z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M42 4v5h2v3h14a2 2 0 0 1 2 2V56A4 4 0 0 1 56 60H4a4 4 0 0 1-4-4.01V14a2 2 0 0 1 2-2h14V9h2V4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4zM22 4h16v5h2V4a2 2 0 0 0-2-2H22a2 2 0 0 0-2 2v5h2V4zm20 7h-6v1h6v-1zm-8 0V9h2V6H24v3h2v3h8v-1zm-10 0h-6v1h6v-1zm28 27a6 6 0 0 0 6-6V14h-1v18a5 5 0 0 1-5 5H35.24a3 3 0 0 1 .59 1H52zm6-.7a7.98 7.98 0 0 1-6 2.7H36v6a3 3 0 0 1-3 3c-.55 0-1.31.31-1.71.71L30 51l-1.29-1.29c-.4-.4-1.15-.71-1.72-.71A3 3 0 0 1 24 46v-6H8a7.98 7.98 0 0 1-6-2.7v18.69A2 2 0 0 0 4 58h52a2 2 0 0 0 2-2.01v-18.7zM25 42v4c0 1.1.9 2 2 2 .82 0 1.84.42 2.42 1l.58.59.58-.59c.59-.58 1.6-1 2.43-1A2 2 0 0 0 35 46v-4h-1v1a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3v-1h-1zm3 1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h-4v1zm6-4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v1h8v-1zm-9.83-1a3 3 0 0 1 .6-1H8a5 5 0 0 1-5-5V14H2v18a6 6 0 0 0 6 6h16.17zM27 36h6v-2.59l-3-3-3 3V36zm29-22H4v18a4 4 0 0 0 4 4h18v-3l3.3-3.3.7-.7.7.7L34 33v3h18a4 4 0 0 0 4-4V14zM4 40v16h26v1H4a1 1 0 0 1-1-1V40h1zm4-24h24v1H8v-1z"
    ></path>
  </svg>
</template>
